import React, { useEffect, useState,useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
///import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import { ChevronLeft, User, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun,DollarSign, Camera,MapPin ,Layout , Box, Briefcase,Bell, FileText, Users, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, BarChart2,Home } from 'react-feather';
import { 
  FaUsers, 
  FaBriefcase, 
  FaCalendarAlt, 
  FaPlaneArrival, 
  FaPlaneDepartureen , 
  FaBed,
  FaPlaneDeparture,
  FaDoorOpen , 
  FaClock 
} from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = { t: (key) => key }; // Returns the key itself as a fallback


  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("employee-dashboard");

  const profileTabRef = useRef(null);

  useEffect(() => {
    // Trigger the click event when the component mounts
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);


  useEffect(() => {
    const menuMapping = {
        '/hospitality': 'employee',
        '/departments': 'employee',
        '/designations': 'employee',
        '/profile': 'profile',
        '/leave-types': 'employee',
        '/holidays': 'employee',
        '/shift-list': 'employee',
        '/overtime': 'employee',
        '/announcements': 'employee',
        '/leaves-employee': 'leaves',
        '/adminleaves': 'leaves',
        '/leave-applications': 'leaves',
        '/leaves-balance': 'leaves',
        '/leave-settings': 'leaves',
        '/attendance-weekly': 'attendance',
        '/attendance-daily': 'attendance',
        '/adminattendance': 'attendance',
        '/attendance-employee': 'attendance',
        '/payroll-overview': 'payroll-overview',
        '/salary': 'payroll-overview',
        '/payroll-items': 'payroll-overview',
        '/run-payroll': 'payroll-overview',
        '/payroll-settings': 'payroll-overview',
        '/payroll-history': 'payroll-overview',
        '/payroll-reports': 'payroll-overview',
        
        
        '/devices': 'devices',
        '/deviceslog': 'devices',
        '/device-users': 'devices',
        
        '/manage-locations': 'company-settings',
        '/manage-locations': 'company-settings',
        '/manage-locations': 'company-settings',

        

        '/reports': 'reports',
        '/pos-configuration': 'pos-configuration',
        // Add more routes as necessary
    };

    const matchedMenu = Object.keys(menuMapping)
    .sort((a, b) => b.length - a.length) // Sort longest paths first
    .find(route => pathname.startsWith(route)) || ""; // Find the best match


    if (matchedMenu) {
        toggleSidebar(menuMapping[matchedMenu]);
    } else {
        toggleSidebar('dashboard'); // Default menu if no match
    }
}, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');

    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
        const updatedSection = { ...section };
        updatedSection.menu = section.menu.map((menuItem) =>
            menu.menuValue !== menuItem.menuValue
                ? { ...menuItem, showSubRoute: false }
                : { ...menuItem, showSubRoute: true }
        );
        return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
};


  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const isActive1 = (routes) => {
    return routes.some(route => pathname.includes(route));
  };

  const isActive = (routes) => {
    const currentPath = window.location.pathname.replace(/\/$/, ""); // Normalize trailing slashes
    const routeArray = Array.isArray(routes) ? routes : [routes]; // Handle single route or array
    return routeArray.some(path => currentPath === path.replace(/\/$/, "")); // Exact match
  };

  return (
    <div className="sidebar">
      <div className="sidebar-inner slimscroll-" style={{ overflow: false }}>
        <div id="sidebar-menu" className="sidebar-menu">
          <nav className="greedys sidebar-horizantal" id="horizantal-sidebar">
            {/* Horizontal Sidebar content */}
          </nav>

          <Scrollbars
            autoHide={false}
            autoHideTimeout={1000}
            autoHideDuration={200}
            autoHeight
            autoHeightMin={0}
            autoHeightMax="100vh"
            thumbMinSize={30}
            universal={false}
            hideTracksWhenNotNeeded={true}
          >
            <ul className="sidebar-vertical" id="veritical-sidebar">
              {sidebarData.map((mainTittle, index) => (
                <>
                  <li className="menu-title" key={index + 1}>
                    <span>{t(mainTittle.tittle)}</span>
                  </li>
                  {mainTittle.menu.map((menu, menuIndex) => (
                    <>
                      {!menu.hasSubRoute ? (
                        <li key={menuIndex + 1}>
                          <Link
                            to={menu.route}
                            className={isActive([menu.route]) ? "active" : ""}
                          >
                            <i className={menu?.icon} />
                            <span>{t(menu.menuValue)}</span>
                          </Link>
                        </li>
                      ) : (
                        <li className="submenu">
                          <Link
                            to="#"
                            onClick={() => expandSubMenus(menu)}
                            className={menu.showSubRoute ? "subdrop" : ""}
                          >
                            <i className={menu?.icon} />
                            <span>{t(menu.menuValue)}</span>
                            <span className="menu-arrow" />
                          </Link>
                          <ul
                            style={{
                              display: menu.showSubRoute ? "block" : "none",
                            }}
                          >
                            {menu.subMenus.map((subMenus, subMenu) => (
                              <>
                                {subMenus?.showMenuRoute ? (
                                  <li key={subMenu + 1}>
                                    <Link
                                      to={subMenus.route}
                                      className={isActive([subMenus.route]) ? "active" : ""}
                                    >
                                      {t(subMenus.menuValue)}
                                      <span className="menu-arrow" />
                                    </Link>
                                    <ul
                                      style={{
                                        display: subMenus.showSubRoute ? "block" : "none",
                                      }}
                                    >
                                      {subMenus?.subMenusValues?.map((value, index) => (
                                        <li key={index}>
                                          <Link 
                                            to={value.route}
                                            className={isActive([value.route]) ? "active" : ""}
                                          >
                                            <span>{t(value.menuValue)}</span>
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ) : (
                                  <li key={subMenu + 1}>
                                    <Link
                                      to={subMenus.route}
                                      className={isActive([subMenus.route]) ? "active" : ""}
                                    >
                                      {t(subMenus.menuValue)}
                                    </Link>
                                    <ul>
                                      {subMenus?.subMenusValues?.map((value, index) => (
                                        <li key={index}>
                                          <Link 
                                            to={value.route}
                                            className={isActive([value.route]) ? "active" : ""}
                                          >
                                            {t(value.menuValue)}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                )}
                              </>
                            ))}
                          </ul>
                        </li>
                      )}
                    </>
                  ))}
                </>
              ))}
            </ul>
          </Scrollbars>
        </div>
      </div>

      <div className="two-col-bar" id="two-col-bar">
        <div className="sidebar sidebar-twocol">
          <div className="sidebar-left slimscroll">
            <div
              className="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >  
       

              <Link
  className={`nav-link ${isActive(["/pos/pos-configuration", "/departments", "/designations", "/profile", "/leave-types", "/holiday", "/shift-list", "/overtime"]) ? "active" : ""}`}
  title="My Property"
  onClick={() => toggleSidebar("/pos/pos-configuration")}
  to="/pos/pos-configuration"
>
  <span className="material-icons-outlined">business</span>
  <small>MIS</small>
</Link>

<Link
      className={`nav-link ${isActive(["/pos/table-overview", "/hospitality/guest-reservation"]) ? "active" : ""}`}
      title="Bookings"
      onClick={() => toggleSidebar("/pos/table-overview")}
      to="/pos/table-overview"
    >
      <span className="material-icons-outlined">book_online</span>
      <small>Billing</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/pos/reservations", "/pos/reservation-widget"]) ? "active" : ""}`}
      title="POS Bills"
      onClick={() => toggleSidebar("/pos/reservations")}
      to="/pos/reservations"
    >
      <span className="material-icons-outlined">description</span>
      <small>Reservations</small>
    </Link>


 <Link
      className={`nav-link ${isActive(["/pos/bill-list", "pos/bill-list"]) ? "active" : ""}`}
      title="POS Bills"
      onClick={() => toggleSidebar("/pos/bill-list")}
      to="/pos/bill-list"
    >
      <span className="material-icons-outlined">description</span>
      <small>Bills</small>
    </Link>


    <Link
      className={`nav-link ${isActive(["/pos/day-end"]) ? "active" : ""}`}
      title="Day End"
      onClick={() => toggleSidebar("/pos/day-end")}
      to="/pos/day-end"
    >
      <span className="material-icons-outlined">nights_stay</span>
      <small>Day End</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/pos/day-book"]) ? "active" : ""}`}
      title="Day Book"
      onClick={() => toggleSidebar("/pos/day-book")}
      to="/pos/day-book"
    >
      <span className="material-icons-outlined">book</span>
      <small>Day Book</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/pos/reports"]) ? "active" : ""}`}
      title="Settings"
      onClick={() => toggleSidebar("/pos/reports")}
      to="/pos/reports"
    >
      <span className="material-icons-outlined">insert_chart</span>
      <small>Reports</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/Marketing"]) ? "active" : ""}`}
      title="marketingss"
      onClick={() => toggleSidebar("/marketing")}
      to="#"
    >
      <span className="material-icons-outlined">help_outline</span>
      <small>Support</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/support"]) ? "active" : ""}`}
      title="Support"
      onClick={() => toggleSidebar("/support")}
      to="#"
    >
      <span className="material-icons-outlined">help_outline</span>
      <small>Support</small>
    </Link>

    <Link
      className={`nav-link ${isActive(["/logout"]) ? "active" : ""}`}
      title="Logout"
      onClick={() => toggleSidebar("/logout")}
      to="#"
    >
      <span className="material-icons-outlined">exit_to_app</span>
      <small>Logout</small>
    </Link>
            </div>
          </div>

          <div className="sidebar-right">
       
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
